import {
  EventDefinition,
  EventParams,
  MpEvent,
  MpProperty,
  PropertyDefinition,
  PropertyParams,
} from 'common/util/definitions-types';

// @ts-check
import {getProjectId, getWorkspaceId} from '../report/util';
import {eventDefinitionsClient} from '../report/queries/app-api/event-definitions-client';
import {propertyDefinitionsClient} from '../report/queries/app-api/property-definitions-client';

function fetchDefinitions(
  queryClient,
  params: EventParams | PropertyParams = {},
  options: Record<string, any> = {},
): Promise<any> {
  const projectId = params.projectId || getProjectId();
  const workspaceId = params.workspaceId || getWorkspaceId();
  return queryClient.query({...params, projectId, workspaceId}, options);
}

export async function fetchEventDefinitions(
  params: EventParams = {},
  options: Record<string, any> = {},
): Promise<EventDefinition[]> {
  return fetchDefinitions(eventDefinitionsClient, params, options);
}

export function fetchPropertyDefinitions(
  params: PropertyParams,
  options: Record<string, any> = {},
): Promise<PropertyDefinition[]> {
  return fetchDefinitions(propertyDefinitionsClient, params, options);
}

export function getDefinitionForEvent(mpEvent: MpEvent, eventDefinitions: EventDefinition[]): EventDefinition | null {
  let predicate = (definition) => {
    return (
      (definition.name === mpEvent.name || definition.name === mpEvent.value) &&
      !definition.collectEverythingEventId &&
      !definition.customEventId
    );
  };
  if (mpEvent.is_collect_everything_event) {
    predicate = (definition) => definition.collectEverythingEventId === mpEvent.id;
  } else if (mpEvent.custom) {
    predicate = (definition) => definition.customEventId === mpEvent.id;
  }

  const eventDefinition = eventDefinitions.find(predicate);
  return eventDefinition ? eventDefinition : null;
}

export function getDefinitionForProperty(
  mpProperty: MpProperty,
  propertyDefinitions: PropertyDefinition[],
): PropertyDefinition | null {
  let propertyDefinition = propertyDefinitions.find((definition) => {
    const definitionIsCustom = definition.status === `custom`;
    const propertyIsCustom = !!mpProperty.customPropertyId;
    // both need to be custom or non-custom at the same time
    if (definitionIsCustom === propertyIsCustom) {
      if (definitionIsCustom) {
        return definition.customPropertyId.toString() === mpProperty.customPropertyId.toString();
      } else {
        return definition.name === mpProperty.name;
      }
    }
    return false;
  });

  if (propertyDefinition && mpProperty.tempDataGroupId) {
    propertyDefinition = {
      ...propertyDefinition,
      type: `dimension`,
      dimension_data_group_id: mpProperty.tempDataGroupId,
    };
  }

  return propertyDefinition ? propertyDefinition : null;
}
